export default __webpack_public_path__ + "static/media/img6.94af14cf.jpg";